import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ComplaintsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfileComplaints' */ './components/Complaints'
		)
);

export default () => ({
	path: 'complaints',
	element: <AsyncLoading component={<ComplaintsLazy />} />,
});
